export default {"src":"/_next/static/media/bg-mob.09e3a232.svg","height":765,"width":428,"blurWidth":0,"blurHeight":0};